import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import 'materialize-css/dist/css/materialize.min.css';

import LoginForm from './components/LoginForm';
import Error404 from './components/Error404';

import './App.css';
import CreateUser from './components/CreateUser';
import GiftForm from './components/GiftForm';
import ChooseGift from './components/ChooseGift';
import RequestGift from './components/RequestGift';
import Logout from './components/Logout';

import './style/global.css';

class App extends Component {

    constructor(props) {
        super(props);
        localStorage.setItem('api', window.location.hostname === 'localhost'
            ? 'http://localhost:3001/api' : 'https://soymas.th.si-3.tech/api');
    }

    updateParentByChild() {
        this.forceUpdate()
    }

    render() {
        if (localStorage.getItem('jwtToken')) {
            return (
                <div className="App" >
                    <BrowserRouter>
                        <div>
                            <Switch>
                                <Route path="/" component={ChooseGift} exact />
                                <Route path="/login" render={
                                    (props) => <LoginForm {...props} updateParent={() => this.forceUpdate()} />
                                } />
                                {/* <Route path="/dar_puntos" component={GivePoints} /> */}
                                <Route path="/crear_usuario" component={CreateUser} />
                                <Route path="/regalos" component={GiftForm} />
                                <Route path="/redimir_puntos" component={ChooseGift} />
                                <Route path="/solicitud" component={RequestGift} />
                                <Route path="/logout" component={Logout} />
                                <Route component={Error404} />
                            </Switch>
                        </div>
                    </BrowserRouter>
                </div>
            );
        } else {
            return (
                <div className="App" >
                    <BrowserRouter>
                        <Route path="/" render={
                            (props) => <LoginForm {...props} updateParent={() => this.forceUpdate()} />
                        } />
                    </BrowserRouter>
                </div>
            );
        }

    }
}

export default App;